// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-ug_","question":"styles_question__1Iz9M","description":"styles_description__3vTDw"};